var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactMessegingIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 4C3.99238 4 2.5 5.53502 2.5 7.42857V16.5714C2.5 18.465 3.99238 20 5.83333 20H19.1667C21.0076 20 22.5 18.465 22.5 16.5714V7.42857C22.5 5.53502 21.0076 4 19.1667 4H5.83333ZM8.12469 8.21913C7.69343 7.87412 7.06414 7.94404 6.71913 8.37531C6.37412 8.80657 6.44404 9.43586 6.87531 9.78087L11.8753 13.7809L12.5 14.2806L13.1247 13.7809L18.1247 9.78087C18.556 9.43586 18.6259 8.80657 18.2809 8.37531C17.9359 7.94404 17.3066 7.87412 16.8753 8.21913L12.5 11.7194L8.12469 8.21913Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactMessegingIc);
export default __webpack_public_path__ + "static/media/contactMesseging_ic.47961638.svg";
export { ForwardRef as ReactComponent };